/*@ngInject*/
const OptionGroupRadioButtonsController = function ($rootScope, $element, localization,
                                                    configurationConstant) {
    $element.addClass('optionGroupRadioButtons');

    localization.getTranslationByKey('optionGroupRadioButtons').then(function (translations) {
        this.init = function () {
            this.radioButtonValue = this.value || '';
        };

        this.handleChange = function () {
            $rootScope.$broadcast(configurationConstant.event.OPTION_GROUP_INPUT_VALUE_CHANGED, {
                name: this.name,
                value: this.radioButtonValue
            });
        };

        this.init();
    }.bind(this));
};

angular.module('ums.configuration')
    .controller('optionGroupRadioButtonsController', OptionGroupRadioButtonsController);
